import Core from './core';
import AssetsPreload from './assets_preload.json';
import AssetsPreloadMobile from './assets_preload_mobile.json';
import AssetsLoad from './assets_load.json';
import AssetsLoadMobile from './assets_load_mobile.json';
import {isMobile} from '../viewport';

const preloader = ({onComplete, onProgress, onError}) => {
    const loader = new Core({
        assets: isMobile() ? AssetsPreloadMobile : AssetsPreload,
        onComplete,
        onProgress,
        onError
    });

    return loader;
}

const loader = ({onComplete, onProgress, onError}) => {
    const loader = new Core({
        assets: isMobile() ? AssetsLoadMobile : AssetsLoad,
        onComplete,
        onProgress,
        onError
    });

    return loader;
}

export default {
    preloader,
    loader
}